import { useContext } from "react";
import AppContext from "../../contexts/AppContext";
import StyledDetaEntryFormDisclaimerModal from "../../styles/StyledDetaEntryFormDisclaimerModal";

const DetaEntryFormDisclaimerModal = () => {
  const { configuration } = useContext(AppContext);

  if (!configuration) return <></>;

  return (
    <StyledDetaEntryFormDisclaimerModal>
      <div
        dangerouslySetInnerHTML={{
          __html: configuration.user_data_prompt_html_disclaimer,
        }}
      />
    </StyledDetaEntryFormDisclaimerModal>
  );
};

export default DetaEntryFormDisclaimerModal;
